var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_960_009771"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_960_009771)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.800048828125,0L11.200048828125,0C11.641848828125,0,12.000048828125,0.358172,12.000048828125,0.8C12.000048828125,1.24183,11.641848828125,1.6,11.200048828125,1.6L4.800048828125,1.6C4.3582188281250005,1.6,4.000048828125,1.24183,4.000048828125,0.8C4.000048828125,0.358172,4.3582188281250005,0,4.800048828125,0ZM1.600048828125,3.2L14.400048828125,3.2C14.841848828125,3.2,15.200048828125,3.55817,15.200048828125,4C15.200048828125,4.44183,14.841848828125,4.8,14.400048828125,4.8L13.600048828125,4.8L13.600048828125,14.4C13.600048828125,15.2837,12.883748828125,16,12.000048828125,16L4.000048828125,16C3.116388828125,16,2.400048828125,15.2837,2.400048828125,14.4L2.400048828125,4.8L1.600048828125,4.8C1.158220828125,4.8,0.800048828125,4.44183,0.800048828125,4C0.800048828125,3.55817,1.158220828125,3.2,1.600048828125,3.2ZM4.000048828125,4.8L12.000048828125,4.8L12.000048828125,14.4L4.000048828125,14.4L4.000048828125,4.8ZM7.200048828125,12L7.200048828125,7.2C7.200048828125,6.75817,6.841878828125,6.4,6.400048828125,6.4C5.958218828125,6.4,5.600048828125,6.75817,5.600048828125,7.2L5.600048828125,12C5.600048828125,12.4418,5.958218828125,12.8,6.400048828125,12.8C6.841878828125,12.8,7.200048828125,12.4418,7.200048828125,12ZM10.450048828125,12L10.450048828125,7.2C10.450048828125,6.75817,10.091878828125,6.4,9.650048828125,6.4C9.208218828125,6.4,8.850048828125,6.75817,8.850048828125,7.2L8.850048828125,12C8.850048828125,12.4418,9.208218828125,12.8,9.650048828125,12.8C10.091878828125,12.8,10.450048828125,12.4418,10.450048828125,12Z",
    fillRule: "evenodd",
    fill: "#9DA2AD",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.53aedb83ca87306326ce10193fa65e14.svg";
export { ForwardRef as ReactComponent };